import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Filter } from 'lucide-react';
import { portfolioProjects } from '../mock';
import { SEO } from '../components/SEO';

export const Portfolio = () => {
  const [filter, setFilter] = useState('All');
  const categories = ['All', 'Website Development', 'Web App Development', 'Mobile App Development'];

  const filteredProjects = filter === 'All'
    ? portfolioProjects
    : portfolioProjects.filter(project => project.category === filter);

  return (
    <div className="dark-container">
      <SEO 
        title="Our Portfolio - Website & App Development Projects in Bhubaneswar | NEXEN DIGITAL"
        description="View our portfolio of successful website development and app development projects in Bhubaneswar. See our work in custom web design, mobile apps, and software solutions delivered to clients in Odisha and across India."
        keywords="website development portfolio bhubaneswar, app development projects, web design portfolio, mobile app projects, case studies, our work, bhubaneswar, odisha"
      />
      {/* Hero Section */}
      <section style={{ padding: '100px 0 60px', textAlign: 'center' }}>
        <h1 className="display-huge" style={{ marginBottom: '24px', color: '#FFFFFF' }}>
          Our <span style={{ color: '#00FFD1' }}>Portfolio</span>
        </h1>
        <p className="body-large" style={{ maxWidth: '800px', margin: '0 auto', color: 'rgba(255, 255, 255, 0.85)' }}>
          Explore our latest projects showcasing innovation, creativity, and technical excellence powered by AI.
        </p>
      </section>

      {/* Filter Section */}
      <section style={{ padding: '40px 0' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '40px', flexWrap: 'wrap' }}>
            <Filter size={24} style={{ color: '#00FFD1' }} />
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
              {categories.map((cat) => (
                <button
                  key={cat}
                  onClick={() => setFilter(cat)}
                  style={{
                    background: filter === cat ? '#00FFD1' : 'rgba(255, 255, 255, 0.1)',
                    color: filter === cat ? '#000000' : '#FFFFFF',
                    border: 'none',
                    borderRadius: '0px',
                    padding: '12px 24px',
                    fontSize: '16px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                >
                  {cat}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <section style={{ padding: '40px 0 100px' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(400px, 1fr))', gap: '40px' }}>
            {filteredProjects.map((project) => (
              <div
                key={project.id}
                style={{
                  background: '#121212',
                  border: '1px solid rgba(255, 255, 255, 0.25)',
                  padding: '40px',
                  transition: 'all 0.4s ease-in-out',
                  cursor: 'pointer'
                }}
                className="portfolio-card"
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '20px' }}>
                  <span style={{ fontSize: '14px', color: '#00FFD1', fontWeight: '500' }}>
                    {project.category}
                  </span>
                  <span style={{ fontSize: '14px', color: '#FFFFFF' }}>
                    {project.year}
                  </span>
                </div>
                <h3 className="heading-1" style={{ marginBottom: '16px', color: '#FFFFFF' }}>
                  {project.title}
                </h3>
                <p className="body-medium" style={{ marginBottom: '24px', color: 'rgba(255, 255, 255, 0.85)' }}>
                  {project.description}
                </p>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '24px' }}>
                  {project.technologies.map((tech, idx) => (
                    <span
                      key={idx}
                      style={{
                        background: 'rgba(0, 255, 209, 0.1)',
                        color: '#00FFD1',
                        padding: '6px 12px',
                        fontSize: '14px',
                        border: '1px solid rgba(0, 255, 209, 0.3)'
                      }}
                    >
                      {tech}
                    </span>
                  ))}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#00FFD1', fontSize: '16px', fontWeight: '500' }}>
                  View Details
                  <ArrowRight size={20} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{ padding: '100px 0', background: '#121212' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
          <h2 className="display-large" style={{ marginBottom: '24px', color: '#FFFFFF' }}>
            Have a <span style={{ color: '#00FFD1' }}>Project in Mind?</span>
          </h2>
          <p className="body-large" style={{ marginBottom: '40px', color: 'rgba(255, 255, 255, 0.85)' }}>
            Let's create something extraordinary together. Share your vision with us.
          </p>
          <Link to="/contact" className="btn-primary">
            Start Your Project
            <ArrowRight size={20} />
          </Link>
        </div>
      </section>
    </div>
  );
};